// console.log('start news');

function getNews() {

  let newsContainer = document.querySelector('#lNews');
  let page = newsContainer.getAttribute('data-news');
  let catID = newsContainer.getAttribute('data-cat') || 0;
  let artID = $.urlParam('artid') || false;
  let pageLang = $('html').attr('lang');
  let q = '';

  const apiUrl = '/news-api/';
  const qElement = document.getElementById('news-qs');

  if (qElement) {
    q = qElement.value;
  }
  const data = (artID) ?
    {
      article_id: artID,
      lang: pageLang,
    }
    : {
      page: page,
      items: 6,
      category: catID,
      lang: pageLang,
      q: q
    };

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: new URLSearchParams(data).toString()
  };

  switchBlock('#newsSpinner', 'on')
  fetch(apiUrl, options)
    .then(response => {
      if (!response.ok) {
        throw new Error(`Connection error: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      let numberOfNews = data.items.length;
      if (artID > 0) {
        if (numberOfNews === 0) {
          switchBlock('#news-not-found', 'on')
        } else {
          drawSingle(data.items);
        }
      } else {
        data.items.forEach(item => {
          drawNews(item);
        });

        if (numberOfNews === 6) {
          newsContainer.setAttribute('data-news', parseInt(page) + 1);
          $('#shMo').show();
        } else if (numberOfNews > 0) {
          $('#shMo').hide();
        } else {
          $('#shMo').hide();
          switchBlock('#news-not-found', 'on')
        }
      }
    })
    .catch(error => {
      console.error('Server error:', error);
    });

  switchBlock('#newsSpinner', 'off')

  return false;

  function decodeHtmlEntities(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.documentElement.textContent;
  }

  function switchBlock(selector, status) {
    document.querySelector(selector).classList.toggle('d-none', status !== 'on');
  }

  function drawSingle(news) {
    let tags = '';
    let cat = news['category_name'].split(',');
    for (let j = 0; cat.length > j; j++) tags += '<span class="tag">' + cat[j] + '</span>';
    const e = document.createElement('div');
    e.classList.add('item');
    e.classList.add('full');
    console.log(news);
    e.innerHTML = `
      <h2>${decodeHtmlEntities(news.title)}</h2>
      <div class="first-blick-on-bottom-of-header">
          <p class="d p14 date">${news.created}</p>
          <div class="tags">${tags}</div>
      </div>
      <div class="im"><img src="${news.image}" alt="${news.title}"></div>
      <div class="des"><div class="full-txt">${decodeHtmlEntities(news.body_full)}</div></div>`;
    document.querySelector('#lNews').append(e);
  }

  function drawNews(news) {

    // let tags = '';
    let cat = news['category_name'].split(',');
    // for (let j = 0; cat.length > j; j++) tags += '<span class="tag">' + cat[j] + '</span>';

    const e = document.createElement('div');
    e.classList.add('item');
    e.innerHTML = `<div class="im"><a href="?artid=${news.id}#tNews"><img src="${news.image}" alt="${news.title}"></a></div>
        <div class="des margin-box space-300">
          <div class="margin-box space-100">
            <p class="font-body-button-s content-tertiary">${cat.join(' ')}</p>
            <a class="font-headline-xs font-link" href="?artid=${news.id}#tNews"><h2 class="font-headline-xs">${decodeHtmlEntities(news.title)}</h2></a>
            <p class="text font-body-s">${decodeHtmlEntities(news.body)}</p>
          </div>
          <div class="tags"><span class="tag">${news.estimate}</span></div>
        </div>`;

    document.querySelector('#lNews').append(e);
  }
}


$.urlParam = function (name) {
  // console.log(name);

  let results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  // console.log(results);

  if (results == null) return null;
  else return results[1] || 0;
};

$(document).ready(function () {

  if ($('#lNews')[0]) {

    /**
     * For News page (LIST)
     **/
    if (document.querySelector('.ico-search')) {
      /**
       * Manage TABS
       */
      let items = document.querySelectorAll('.scSearch .item');

      let currentCat = 0;
      let currentPage = 0;
      let searchIcon = document.querySelector('.ico-search');
      const lNews = document.querySelector('#lNews');

      /**
       * manage search panel
       */
      searchIcon.addEventListener('click', function () {
        let elements = document.querySelectorAll('.ico-search, .plSearch');

        elements.forEach(function (element) {
          element.classList.toggle('open');
          if (!element.classList.contains('open')) {
            document.getElementById('news-qs').value = '';
          }
        });
      });

      function resetNewsBlock() {
        lNews.innerHTML = '';
        lNews.setAttribute('data-news', 0);
        document.querySelector('#news-not-found').classList.add('d-none');
        currentPage = 0;
      }

      items.forEach(function (item) {
        item.addEventListener('click', function () {
          items.forEach(function (innerItem) {
            innerItem.classList.remove('active');
          });
          item.classList.add('active');
          currentCat = item.dataset.target;
          lNews.setAttribute('data-cat', currentCat);
          resetNewsBlock();
          getNews();
        });
      });

      document.getElementById('news-qs').addEventListener('keyup', function (event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          resetNewsBlock();
          getNews();
        }
      });


    } else {
      /**
       * For single news
       **/
      // console.log(' single news page');
      $('#shMo').hide();
      document.querySelector('#after-single-news').classList.remove('d-none');
    }
    getNews();
  }

});